export const PACKAGE = {
  CSV: 1,
  API: 2
};

export const API_STATUS = {
  INACTIVE: 0,
  WAITING_APPROVAL: 1,
  ACTIVE: 2
};

export const CALLBACK_TYPE = {
  SUCCESS: 1,
  FAILED: 2,
  APPROVED: 3,
  REJECTED: 4
};

export const ERROR_API_SETTING = {
  INACTIVE: 9000,
  WAITING_APPROVAL: 9016,
  TW0_FA_EXPIRED: 2014
};

export const NAV_MENUS = {
  api: "API Keys",
  callbacks: "Callbacks",
  twoFa: "Two-Factor Authentication"
};

export const API_SETTINGS_COMPANY_IDS = [
  8690, // munadiarh - Production
  11424, // fliptest - Production
  41322, // fliptest1507f - Production
  870416, // pliffers24 - Devbox
  8695 // cobaxx
];

export const SNAP_OBJECT_KEYS = {
  CLIENT_ID: "client_id",
  CLIENT_SECRET: "client_secret",
  PUBLIC_KEY: "public_key"
};

export const SNAP_CREDENTIAL_TYPES = {
  CLIENT_ID: "snap-client-id",
  CLIENT_SECRET: "snap-client-secret",
  PUBLIC_KEY: "snap-public-key"
};

export const TIMER_COUNTDOWN_TIME = 300; // 5 minutes (in seconds)
export const TIMER_INTERVAL_TIME = 1000; // 1 seconds (in milliseconds)
export const SHIMMER_LOADING_NEW_API_INFO_TIME = 1000; // 1 seconds (in milliseconds)
export const GET_NEW_API_INFO_INTERVAL_TIME = 10000; // 10 seconds (in milliseconds)

export const DEFAULT_DATE_FORMAT = "dd MMM yyy, HH:mm:ss";
